import { render, staticRenderFns } from "./RoomBooking.vue?vue&type=template&id=137cdc59&scoped=true&"
import script from "./RoomBooking.vue?vue&type=script&lang=js&"
export * from "./RoomBooking.vue?vue&type=script&lang=js&"
import style0 from "./RoomBooking.vue?vue&type=style&index=0&id=137cdc59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137cdc59",
  null
  
)

export default component.exports